/* Revival Hearing — Global JavaScript */

(function() {
  'use strict';

  /* =============================================
     ACCORDION
  ============================================= */
  function initAccordions() {
    document.querySelectorAll('.rh-accordion__trigger').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var item = this.closest('.rh-accordion__item');
        var body = item.querySelector('.rh-accordion__body');
        var icon = this.querySelector('.rh-accordion__icon');
        var isOpen = this.getAttribute('aria-expanded') === 'true';

        // Close all siblings
        var accordion = item.closest('.rh-accordion');
        if (accordion) {
          accordion.querySelectorAll('.rh-accordion__item').forEach(function(sibling) {
            if (sibling !== item) {
              var sibTrigger = sibling.querySelector('.rh-accordion__trigger');
              var sibBody = sibling.querySelector('.rh-accordion__body');
              var sibIcon = sibling.querySelector('.rh-accordion__icon');
              if (sibTrigger) sibTrigger.setAttribute('aria-expanded', 'false');
              if (sibBody) { sibBody.style.maxHeight = '0'; sibBody.style.opacity = '0'; }
              if (sibIcon) sibIcon.textContent = '+';
            }
          });
        }

        if (isOpen) {
          this.setAttribute('aria-expanded', 'false');
          body.style.maxHeight = '0';
          body.style.opacity = '0';
          if (icon) icon.textContent = '+';
        } else {
          this.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = body.scrollHeight + 'px';
          body.style.opacity = '1';
          if (icon) icon.textContent = '×';
        }
      });
    });
  }

  /* =============================================
     ANNOUNCEMENT BAR TICKER
  ============================================= */
  function initAnnouncementTicker() {
    var ticker = document.querySelector('.rh-announcement__track');
    if (!ticker) return;
    var items = ticker.querySelectorAll('.rh-announcement__item');
    if (items.length <= 1) return;

    var current = 0;
    items.forEach(function(item, i) {
      item.style.display = i === 0 ? 'flex' : 'none';
    });

    setInterval(function() {
      items[current].style.opacity = '0';
      setTimeout(function() {
        items[current].style.display = 'none';
        current = (current + 1) % items.length;
        items[current].style.display = 'flex';
        items[current].style.opacity = '0';
        setTimeout(function() { items[current].style.opacity = '1'; }, 20);
      }, 300);
    }, 4000);

    items.forEach(function(item) {
      item.style.transition = 'opacity 0.3s ease';
    });
  }

  /* =============================================
     STICKY HEADER
  ============================================= */
  function initStickyHeader() {
    var header = document.querySelector('.rh-header');
    if (!header) return;
    var scrolled = false;

    window.addEventListener('scroll', function() {
      if (window.scrollY > 80) {
        if (!scrolled) { header.classList.add('rh-header--scrolled'); scrolled = true; }
      } else {
        if (scrolled) { header.classList.remove('rh-header--scrolled'); scrolled = false; }
      }
    }, { passive: true });
  }

  /* =============================================
     MOBILE MENU
  ============================================= */
  function initMobileMenu() {
    var toggle = document.querySelector('.rh-header__menu-toggle');
    var nav = document.querySelector('.rh-header__nav');
    var overlay = document.querySelector('.rh-mobile-overlay');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function() {
      var isOpen = nav.classList.contains('rh-header__nav--open');
      nav.classList.toggle('rh-header__nav--open', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
      document.body.style.overflow = isOpen ? '' : 'hidden';
      if (overlay) overlay.classList.toggle('rh-mobile-overlay--visible', !isOpen);
    });

    if (overlay) {
      overlay.addEventListener('click', function() {
        nav.classList.remove('rh-header__nav--open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        overlay.classList.remove('rh-mobile-overlay--visible');
      });
    }
  }

  /* =============================================
     STICKY MOBILE CTA BAR
  ============================================= */
  function initStickyMobileCTA() {
    var cta = document.querySelector('.rh-sticky-cta');
    if (!cta) return;
    var hero = document.querySelector('.rh-hero');
    if (!hero) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        cta.classList.toggle('rh-sticky-cta--visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    observer.observe(hero);
  }

  /* =============================================
     SCROLL REVEAL ANIMATIONS
  ============================================= */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rh-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.rh-reveal').forEach(function(el) {
      observer.observe(el);
    });
  }

  /* =============================================
     PRODUCT IMAGE GALLERY
  ============================================= */
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.rh-pdp-gallery__thumb');
    var mainImg = document.querySelector('.rh-pdp-gallery__main-img');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('rh-pdp-gallery__thumb--active'); });
        this.classList.add('rh-pdp-gallery__thumb--active');
        var src = this.querySelector('img').src;
        mainImg.style.opacity = '0';
        setTimeout(function() {
          mainImg.src = src;
          mainImg.style.opacity = '1';
        }, 200);
      });
    });

    mainImg.style.transition = 'opacity 0.2s ease';
  }

  /* =============================================
     CART DRAWER
  ============================================= */
  function initCartDrawer() {
    var drawer = document.querySelector('.rh-cart-drawer');
    var overlay = document.querySelector('.rh-cart-overlay');
    var closeBtn = document.querySelector('.rh-cart-drawer__close');
    var cartTriggers = document.querySelectorAll('[data-cart-trigger]');

    if (!drawer) return;

    function openCart() {
      drawer.classList.add('rh-cart-drawer--open');
      if (overlay) overlay.classList.add('rh-cart-overlay--visible');
      document.body.style.overflow = 'hidden';
    }

    function closeCart() {
      drawer.classList.remove('rh-cart-drawer--open');
      if (overlay) overlay.classList.remove('rh-cart-overlay--visible');
      document.body.style.overflow = '';
    }

    cartTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        openCart();
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    if (overlay) overlay.addEventListener('click', closeCart);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeCart();
    });
  }

  /* =============================================
     ADD TO CART
  ============================================= */
  function initAddToCart() {
    document.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = this.getAttribute('data-variant-id');
        if (!variantId) return;

        var originalText = this.textContent;
        this.textContent = 'Adding...';
        this.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          btn.textContent = 'Added!';
          btn.classList.add('rh-btn--success');
          setTimeout(function() {
            btn.textContent = originalText;
            btn.disabled = false;
            btn.classList.remove('rh-btn--success');
          }, 2000);
          // Update cart count
          return fetch('/cart.js');
        })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          var counts = document.querySelectorAll('.rh-cart-count');
          counts.forEach(function(el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
        })
        .catch(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        });
      });
    });
  }

  /* =============================================
     INIT ALL
  ============================================= */
  document.addEventListener('DOMContentLoaded', function() {
    initAccordions();
    initAnnouncementTicker();
    initStickyHeader();
    initMobileMenu();
    initStickyMobileCTA();
    initScrollReveal();
    initProductGallery();
    initCartDrawer();
    initAddToCart();
  });

})();
